import { useApiClient } from "@/utils/api.util";
import notification from "@/utils/notification.util";

class BaseRepository {
  public client = useApiClient();

  public successToast(message: string) {
    notification.success(message);
  }

  public errorToast(message: string) {
    notification.error(message);
  }

  public async delete(url: string) {
    return this.client.delete(url);
  }
}

export default BaseRepository;
